module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedMedium.8645940.eot";